const NEUTRAL = "border-[#64748B]/40 bg-[#64748B]/10 text-[#94A3B8]";

export const StatusBadge = ({ slug, label, testId }) => (
  <span data-testid={testId}
        className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[10px] uppercase tracking-[0.12em] ${NEUTRAL}`}>
    {label || slug}
  </span>
);

export const ClientStatusCell = ({ client, testId }) => (
  <div className="flex flex-wrap items-center gap-1.5">
    <StatusBadge slug={client.crm_status} label={client.crm_status_label} testId={testId} />
    {(client.derived_badges || []).map((b, i) => (
      <StatusBadge key={b} slug={b} label={(client.derived_labels || [])[i]} />
    ))}
  </div>
);
